export type InventoryIdentity = {
  stock_number?: string | null
  vin?: string | null
  status?: string | null
}

const SOLD_STATUSES = new Set(['sold', 'sold elsewhere'])

export function normalizeStockNumber(value: unknown): string {
  return String(value ?? '').trim().toUpperCase()
}

export function normalizeVin(value: unknown): string {
  return String(value ?? '').trim().toUpperCase()
}

export function isSoldInventoryStatus(status: unknown): boolean {
  return SOLD_STATUSES.has(String(status ?? '').trim().toLowerCase())
}

/**
 * Same VIN may be entered again only after every prior copy is sold.
 * Stock numbers are unique even across sold trucks.
 */
export function inventoryDuplicateMessage(
  incoming: InventoryIdentity,
  existing: InventoryIdentity[],
): string | null {
  const stock = normalizeStockNumber(incoming.stock_number)
  if (stock && existing.some(row => normalizeStockNumber(row.stock_number) === stock)) {
    return `Stock number ${stock} already exists`
  }

  const vin = normalizeVin(incoming.vin)
  if (
    vin &&
    existing.some(row => normalizeVin(row.vin) === vin && !isSoldInventoryStatus(row.status))
  ) {
    return `VIN ${vin} already exists in active inventory`
  }

  return null
}
